import { CreateMeetingPayload } from '@commenda/types/src/meeting/types';
import { fetcher } from '@commenda/utils';

export async function createMeeting(data: CreateMeetingPayload) {
  const res = await fetcher(`meeting`, {
    method: 'POST',
    body: data,
  });

  return res;
}
